module.exports = __webpack_public_path__ + "assets/img/1.a3e6d77b.png";